<div class="auth-main">
	<div class="auth-wrapper v3">
		<div class="auth-form">
			<div class="card mt-5">
				<div class="card-body">
					<form #resetPasswordFrm="ngForm" (ngSubmit)="resetPassword()" [validate-form]="'resetPassword'">
						<a href="javascript:" class="d-flex justify-content-center">
							@if (themeMode === false) {
								<img src="assets/images/vms-logo.png" width="100" alt="logo-img" />
							} @else {
								<img src="assets/images/logo-dark.png" width="100" alt="darkMode-logo" />
							}
						</a>

						<div class="row">
							<div class="d-flex justify-content-center">
								<div class="auth-header text-center">
									<h1 class="text-secondary mt-5"><b>{{"users.reset_password" | translate}}</b></h1>
								</div>
							</div>
						</div>

						<div class="form-floating mb-2">
							<input
								type="{{ newPasswordVisible ? 'text' : 'password' }}"
								class="form-control"
								id="newPassword"
								name="newPassword"
								[(ngModel)]="changePasswordInfo.newPassword"
								placeholder="••••••••"
							/>
							<label for="newPassword">
								{{ "users.new_password" | translate }}<b></b>
							</label>
							<i
								class="fas position-absolute"
								style="top: 10px; right: 10px; cursor: pointer"
								*ngIf="changePasswordInfo.newPassword"
								[ngClass]="newPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
								(click)="newPasswordVisible = !newPasswordVisible"
							></i>
						</div>

						<div class="form-floating mb-2">
							<input
								type="{{ confirmPasswordVisible ? 'text' : 'password' }}"
								class="form-control"
								id="confirmPassword"
								name="confirmPassword"
								[(ngModel)]="changePasswordInfo.confirmPassword"
								placeholder="••••••••"
							/>
							<label for="confirmPassword">
								{{ "users.confirm_password" | translate }}<b></b>
							</label>
							<i
								class="fas position-absolute"
								style="top: 10px; right: 10px; cursor: pointer"
								*ngIf="changePasswordInfo.confirmPassword"
								[ngClass]="confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
								(click)="confirmPasswordVisible = !confirmPasswordVisible"
							></i>
						</div>

						<div class="d-grid mt-4">
							<button
								type="submit"
								class="btn btn-secondary p-2"
								[disabled]="false"
							>
								{{"g.submit" | translate}}
							</button>
						</div>

						<div class="d-grid mt-4">
							<button type="button" class="btn btn-light-secondary" (click)="goBack()">
								{{"g.cancel" | translate}}
							</button>
						</div>
						<hr />
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
